/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Statuses_SolvedInputs */

const es_feedback_statuses_solved = /** @type {(inputs: Feedback_Statuses_SolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resuelto`)
};

const en_feedback_statuses_solved = /** @type {(inputs: Feedback_Statuses_SolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solved`)
};

/**
* | output |
* | --- |
* | "Solved" |
*
* @param {Feedback_Statuses_SolvedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_statuses_solved = /** @type {((inputs?: Feedback_Statuses_SolvedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Statuses_SolvedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_statuses_solved(inputs)
	return en_feedback_statuses_solved(inputs)
});
export { feedback_statuses_solved as "feedback.statuses.solved" }